import { buildTagLink } from '@utils/link';
import NextLink from 'next/link';
import { Container, Item } from './TagList.styles';
import { TagListProps } from './TagList.types';

export const TagList: React.FC<TagListProps> = ({ tags, activeTagId }) => {
  return (
    <Container>
      {tags.map((tag) => (
        <NextLink href={buildTagLink(tag.slug)} passHref>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a>
            <Item key={tag.id} active={tag.id === activeTagId}>
              {tag.name}
            </Item>
          </a>
        </NextLink>
      ))}
    </Container>
  );
};
